import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { TypeDechetDto } from 'src/api/models';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-type-dechet',
  templateUrl: './type-dechet.component.html',
  styleUrls: ['./type-dechet.component.css']
})
export class TypeDechetComponent implements OnInit, OnDestroy {
  @Select(ControlPanelStore.typesDechets$) typesDechets$: Observable<TypeDechetDto[]>;

  private _typeDechetId: number = null
  TypesDechets: TypeDechetDto[] = [];

  @Input() TypesDechetsInput: TypeDechetDto[] = null;
  @Input('height') height: number = 50;

  @Input()
  get typeDechetId() {
    return this._typeDechetId;
  }
  set typeDechetId(val) {
    this._typeDechetId = val;
    this.getTypeDechetInComponent();
  }

  @Input() showImage: boolean = false;
  @Input() showText: boolean = true;

  TypeDechetInComponent: TypeDechetDto;

  td: Subscription;

  constructor() { }

  ngOnInit() {
    this.td = this.typesDechets$.subscribe(res => {
      if (res != null) {
        this.TypesDechets = this.TypesDechetsInput != null ? JSON.parse(JSON.stringify(this.TypesDechetsInput)) : JSON.parse(JSON.stringify(res));
        this.TypeDechetInComponent = this.TypesDechets.find(td => td.Id == this.typeDechetId);
      }
    });
  }

  getTypeDechetInComponent() {
    this.TypeDechetInComponent = this.TypesDechets.find(td => td.Id == this.typeDechetId);
  }

  ngOnDestroy() {
    this.td?.unsubscribe();
  }

  getHeightImage() {
    return this.height;
  }

}
